import { createReducer, on } from '@ngrx/store';
import {
  CHANNEL_SETTING_FIND_SUCCESS,
  CHANNEL_SETTING_FAILURE,
  CHANNEL_SETTING_RESET,
  CHANNEL_SETTING_FIND_ALL_SUCCESS,
  CHANNEL_SETTING_CLEAR_STATE,
  CHANNEL_SETTING_UPDATE_LOADING,
} from '../actions';
import { IResponseBadRequest } from '@core/interfaces';
import { ConfiguracionCanal } from '@core/models';

export interface ConfiguracionCanalState {
  loading: boolean;
  ConfiguracionCanal: ConfiguracionCanal | null;
  ConfiguracionCanalId: string | null;
  ConfiguracionCanalList: ConfiguracionCanal[] | null;
  error: IResponseBadRequest | null;
}

export const initialState: ConfiguracionCanalState = {
  loading: false,
  ConfiguracionCanal: null,
  ConfiguracionCanalId: null,
  ConfiguracionCanalList: null,
  error: null,
};

export const ConfiguracionCanalReducer = createReducer(
  initialState,
  on(CHANNEL_SETTING_FIND_SUCCESS, (state, { ConfiguracionCanal }) => ({ ...state, ConfiguracionCanal })),
  on(CHANNEL_SETTING_FIND_ALL_SUCCESS, (state, { ConfiguracionCanalList }) => ({ ...state, ConfiguracionCanalList })),
  on(CHANNEL_SETTING_FAILURE, (state, { error }) => ({ ...state, error })),
  on(CHANNEL_SETTING_RESET, (state) => ({ ...state, ConfiguracionCanal: null })),
  on(CHANNEL_SETTING_CLEAR_STATE, () => initialState),
  on(CHANNEL_SETTING_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading }))
);
